import { defineComponent as _defineComponent } from 'vue'
interface IUserStatus {
  statusType: number;
  customStatus: string;
}

interface IUserStatusMap {
  [userID: string]: IUserStatus;
}

import { ref, onMounted, onUnmounted } from "../../../adapter-vue";
import TUIChatEngine, {
  TUIStore,
  StoreName,
  TUIConversationService,
  TUITranslateService,
  IConversationModel,
  TUIUserService,
} from "@tencentcloud/chat-uikit-engine";

import {
  TUIGlobal,
  isIOS,
  addLongPressListener,
} from "@tencentcloud/universal-api";
import { accidUsers } from "@/api";
import Icon from "../../common/Icon.vue";
import Avatar from "../../common/Avatar/index.vue";
import ActionsMenu from "../actions-menu/index.vue";
import muteIcon from "../../../assets/icon/mute.svg";
import { isPC, isH5, isUniFrameWork, isMobile } from "../../../utils/env";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: [
  "handleSwitchConversation",
  "getPassingRef",
  "getconversationList",
],
  setup(__props, { expose, emit: emits }) {


const currentConversation = ref<IConversationModel>();
const currentConversationID = ref<string>();
const currentConversationDomRect = ref<DOMRect>();
const isShowOverlay = ref<boolean>(false);
const conversationList = ref<IConversationModel[]>([]);
const lists = ref<any>([]);
const accidUsersList = ref<any>([]);
const conversationListDomRef = ref<HTMLElement | undefined>();
const conversationListInnerDomRef = ref<HTMLElement | undefined>();
const actionsMenuPosition = ref<{
  top: number;
  left: number | undefined;
  conversationHeight: number | undefined;
}>({
  top: 0,
  left: undefined,
  conversationHeight: undefined,
});
const displayOnlineStatus = ref(false);
const userOnlineStatusMap = ref<IUserStatusMap>();

let lastestOpenActionsMenuTime: number | null = null;

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversationID: onCurrentConversationIDUpdated,
    conversationList: onConversationListUpdated,
    currentConversation: onCurrentConversationUpdated,
  });

  TUIStore.watch(StoreName.USER, {
    displayOnlineStatus: onDisplayOnlineStatusUpdated,
    userStatusList: onUserStatusListUpdated,
  });

  if (!isUniFrameWork && isIOS && !isPC) {
    addLongPressHandler();
  }
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversationID: onCurrentConversationIDUpdated,
    conversationList: onConversationListUpdated,
    currentConversation: onCurrentConversationUpdated,
  });

  TUIStore.unwatch(StoreName.USER, {
    displayOnlineStatus: onDisplayOnlineStatusUpdated,
    userStatusList: onUserStatusListUpdated,
  });
});

const isShowUserOnlineStatus = (conversation: IConversationModel): boolean => {
  return (
    displayOnlineStatus.value &&
    conversation.type === TUIChatEngine.TYPES.CONV_C2C
  );
};

const showConversationActionMenu = (
  event: Event,
  conversation: IConversationModel,
  index: number,
  isContextMenuEvent?: boolean
) => {
  if (isContextMenuEvent) {
    event.preventDefault();
    if (isUniFrameWork) {
      return;
    }
  }
  currentConversation.value = conversation;
  lastestOpenActionsMenuTime = Date.now();
  getActionsMenuPosition(event, index);
};

const closeConversationActionMenu = () => {
  // Prevent continuous triggering of overlay tap events
  if (
    lastestOpenActionsMenuTime &&
    Date.now() - lastestOpenActionsMenuTime > 300
  ) {
    currentConversation.value = undefined;
    isShowOverlay.value = false;
  }
};

const getActionsMenuPosition = (event: Event, index: number) => {
  if (isUniFrameWork) {
    if (typeof conversationListDomRef.value === "undefined") {
      emits("getPassingRef", conversationListDomRef);
    }
    const query = TUIGlobal?.createSelectorQuery().in(
      conversationListDomRef.value
    );
    query
      .select(`#convlistitem-${index}`)
      .boundingClientRect((data) => {
        if (data) {
          actionsMenuPosition.value = {
            // The uni-page-head of uni-h5 is not considered a member of the viewport, so the height of the head is manually increased.
            top: data.bottom + (isH5 ? 44 : 0),
            // @ts-expect-error in uniapp event has touches property
            left: event.touches[0].pageX,
            conversationHeight: data.height,
          };
          isShowOverlay.value = true;
        }
      })
      .exec();
  } else {
    const rect =
      (
        (event.currentTarget || event.target) as HTMLElement
      )?.getBoundingClientRect() || {};
    if (rect) {
      actionsMenuPosition.value = {
        top: rect.bottom,
        left: isPC ? (event as MouseEvent).clientX : undefined,
        conversationHeight: rect.height,
      };
    }
    isShowOverlay.value = true;
  }
};

const enterConversationChat = (conversationID: string) => {
  emits("handleSwitchConversation", conversationID);
  TUIConversationService.switchConversation(conversationID);
};

function addLongPressHandler() {
  if (!conversationListInnerDomRef.value) {
    return;
  }
  addLongPressListener({
    element: conversationListInnerDomRef.value,
    onLongPress: (event, target) => {
      const index = (
        Array.from(conversationListInnerDomRef.value!.children) as HTMLElement[]
      ).indexOf(target!);
      showConversationActionMenu(event, conversationList.value[index], index);
    },
    options: {
      eventDelegation: {
        subSelector: ".tui-conversation-content",
      },
    },
  });
}

function onCurrentConversationUpdated(conversation: IConversationModel) {
  currentConversation.value = conversation;
}

async function onConversationListUpdated(list: IConversationModel[]) {
  conversationList.value = list;
  console.log("onConversationListUpdated", 323232323, conversationList.value);
  let accids = list.map((item) => item.userProfile?.userID);
  if (accids.length) {
    accidUsers({ accids: accids.join(",") }).then((res) => {
      accidUsersList.value = res.data;
    });
  }

  let l: any = [];
  let uids = list.map((item) => item.userProfile?.userID);
  for (let i = 0; i < uids.length; i++) {
    if (uids[i]) {
      const userID = uids[i];
      const res = await TUIUserService.getUserProfile({
        userIDList: [userID],
      });
      l.push(
        res.data[0].profileCustomField.some(
          (n) => n.key == "Tag_Profile_Custom_Status" && n.value == "2"
        )
      );
    } else {
      l.push(false);
    }
  }
  lists.value = l;
  emits("getconversationList", list);
}
function showName(userID) {
  let user = accidUsersList.value.filter(
    (item) => item.tencent_accid == userID
  )[0];

  return user ? user.nickname : "";
}
function onCurrentConversationIDUpdated(id: string) {
  currentConversationID.value = id;
}

function onDisplayOnlineStatusUpdated(status: boolean) {
  displayOnlineStatus.value = status;
}

function onUserStatusListUpdated(list: Map<string, IUserStatus>) {
  if (list.size !== 0) {
    userOnlineStatusMap.value = [...list.entries()].reduce(
      (obj, [key, value]) => {
        obj[key] = value;
        return obj;
      },
      {} as IUserStatusMap
    );
  }
}
function getText(conversation) {
  let payload = conversation.lastMessage?.payload;
  let str = "";
  let data = payload?.data;
  // let a = data.replace('"{', "{").replace('}"', "}");
  console.log(payload, 123);
  let d = data ? JSON.parse(data) : {};
  if (d.extension == 1) {
    str = "您发送了岗位信息给对方";
  } else if (d.extension == 2) {
    str = "对方已发送简历";
  } else if (d.extension == 3) {
    str = "已发起面试邀请";
  } 
  else {
    str = "[自定义消息]";
  }
  return str;
  // var e;
  // if (this.draftText) {
  //   return U(this.draftText)["abstract"];
  // }
  // var t = this.getEngine(),
  //   s = t.TUITranslate.t.bind(t.TUITranslate);
  // if (4 === this.operationType) return s("TUIConversation.您已被群管理员移出群聊");
  // if (5 === this.operationType) return s("TUIConversation.该群聊已被解散");
  // if (8 === this.operationType) return s("TUIConversation.您已退出该群聊");
  // var n = this._conversation,
  //   i = this.lastMessage;
  // var r = "",
  //   a = "";
  // var o = n.unreadCount > 0 && n.messageRemindType === t.TYPES.MSG_REMIND_ACPT_NOT_NOTE ? "[".concat(n.unreadCount > 99 ? "99+" : n.unreadCount).concat(s("TUIConversation.条"), "]") : "";
  // if (n.type === t.TYPES.CONV_GROUP) if (i.fromAccount === t.getMyUserID()) r = s("TUIConversation.我");else {
  //   var _e4 = i.fromAccount;
  //   r = t.TUIFriend.getFriendRemark([_e4])[_e4] || i.nameCard || i.nick || _e4;
  // }
  // if (i.type === t.TYPES.MSG_TEXT) a = this.decodeTextMessage(i.payload.text);else if (i.type === t.TYPES.MSG_CUSTOM) {
  //   var _n = U(null === (e = null == i ? void 0 : i.payload) || void 0 === e ? void 0 : e.data);
  //   if (1 === (null == _n ? void 0 : _n.businessID)) return a = t.TUIChat.messageHandler.handleCallKitSignaling(i), a;
  //   a = re.includes(i.messageForShow) ? s("TUIChat.".concat(i.messageForShow)) : i.messageForShow;
  // } else a = re.includes(i.messageForShow) ? s("TUIChat.".concat(i.messageForShow)) : i.messageForShow;
  // return i.isRevoked && (a = s("TUIChat.撤回了一条消息")), n.type === t.TYPES.CONV_GROUP && i.type === t.TYPES.MSG_GRP_TIP ? a : "".concat(o).concat(r ? "".concat(r, ":") : "").concat(a);
}
// Expose to the parent component and close actionsMenu when a sliding event is detected
expose({ closeChildren: closeConversationActionMenu });

return { __sfc: true,emits, currentConversation, currentConversationID, currentConversationDomRect, isShowOverlay, conversationList, lists, accidUsersList, conversationListDomRef, conversationListInnerDomRef, actionsMenuPosition, displayOnlineStatus, userOnlineStatusMap, lastestOpenActionsMenuTime, isShowUserOnlineStatus, showConversationActionMenu, closeConversationActionMenu, getActionsMenuPosition, enterConversationChat, addLongPressHandler, onCurrentConversationUpdated, onConversationListUpdated, showName, onCurrentConversationIDUpdated, onDisplayOnlineStatusUpdated, onUserStatusListUpdated, getText, TUITranslateService, Icon, Avatar, ActionsMenu, muteIcon, isPC, isMobile }
}

})